export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** Часовой пояс отображения календаря CRM (должен совпадать с бэкендом для start_at/end_at). */
export const CRM_CALENDAR_TIMEZONE = 'Europe/Moscow';

/** Часы:минуты начала события в часовом поясе CRM. */
export function formatEventClockInCrmTz(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '00:00';
  const s = new Intl.DateTimeFormat('ru-RU', {
    timeZone: CRM_CALENDAR_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d);
  return s.replace(/\u00a0/g, ' ').trim();
}

/**
 * Календарный день события в CRM (Москва) как локальный Date(y, m-1, d) для подписей в модалках.
 * Интервалы rangeStart/rangeEnd по-прежнему строятся из ISO-инстанта.
 */
export function crmCalendarWallDate(iso: string): Date {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: CRM_CALENDAR_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(d);
  const y = Number(parts.find((p) => p.type === 'year')?.value);
  const m = Number(parts.find((p) => p.type === 'month')?.value);
  const day = Number(parts.find((p) => p.type === 'day')?.value);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(day)) return new Date();
  return new Date(y, m - 1, day);
}

export function monthRangeIso(d: Date): { from: string; to: string } {
  const y = d.getFullYear();
  const m = d.getMonth();
  const last = new Date(y, m + 1, 0);
  return {
    from: `${y}-${pad2(m + 1)}-01`,
    to: `${y}-${pad2(m + 1)}-${pad2(last.getDate())}`,
  };
}

export function calendarEventsQueryKey(from: string, to: string, extraUserIdsKey: string) {
  return ['calendarEvents', from, to, extraUserIdsKey] as const;
}

export function hasProfilePermission(
  profile: { is_system_admin?: boolean; permissions?: Record<string, { slug: string }[]> } | null | undefined,
  slug: string
): boolean {
  if (profile?.is_system_admin) {
    return true;
  }
  if (!profile?.permissions) {
    return false;
  }
  for (const categoryPermissions of Object.values(profile.permissions)) {
    if (Array.isArray(categoryPermissions) && categoryPermissions.some((p) => p.slug === slug)) {
      return true;
    }
  }
  return false;
}
